var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoGold = function SvgInfoGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h13.554v13.554H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 13.554h13.554V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.333 3.333)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.066 3.21a1.006 1.006 0 1 0 1.422 1.423A1.006 1.006 0 0 0 6.066 3.21",
    fill: "#FFC83E"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.179 11.178a6.201 6.201 0 0 1-4.402 1.82 6.206 6.206 0 0 1-4.402-1.82 6.232 6.232 0 0 1 0-8.802 6.232 6.232 0 0 1 8.804 0 6.232 6.232 0 0 1 0 8.802m.392-9.196a6.789 6.789 0 0 0-9.588 0 6.789 6.789 0 0 0 0 9.59 6.761 6.761 0 0 0 4.794 1.982 6.76 6.76 0 0 0 4.794-1.983 6.788 6.788 0 0 0 0-9.589",
    fill: "#FFC83E",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC83E",
    mask: "url(#d)",
    d: "M6.222 10.645h1.11V6.149h-1.11z"
  }))));
};
export { SvgInfoGold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0id2doY3c1bHh6YSIgZD0iTTAgMGgxMy41NTR2MTMuNTU0SDB6Ii8+CiAgICAgICAgPHBhdGggaWQ9ImRveTQyeGV3Y2MiIGQ9Ik0wIDEzLjU1NGgxMy41NTRWMEgweiIvPgogICAgPC9kZWZzPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy4zMzMgMy4zMzMpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik02LjA2NiAzLjIxYTEuMDA2IDEuMDA2IDAgMSAwIDEuNDIyIDEuNDIzQTEuMDA2IDEuMDA2IDAgMCAwIDYuMDY2IDMuMjEiIGZpbGw9IiNGRkM4M0UiLz4KICAgICAgICA8Zz4KICAgICAgICAgICAgPG1hc2sgaWQ9IjVlenpuanExeWIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjd2doY3c1bHh6YSIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMS4xNzkgMTEuMTc4YTYuMjAxIDYuMjAxIDAgMCAxLTQuNDAyIDEuODIgNi4yMDYgNi4yMDYgMCAwIDEtNC40MDItMS44MiA2LjIzMiA2LjIzMiAwIDAgMSAwLTguODAyIDYuMjMyIDYuMjMyIDAgMCAxIDguODA0IDAgNi4yMzIgNi4yMzIgMCAwIDEgMCA4LjgwMm0uMzkyLTkuMTk2YTYuNzg5IDYuNzg5IDAgMCAwLTkuNTg4IDAgNi43ODkgNi43ODkgMCAwIDAgMCA5LjU5IDYuNzYxIDYuNzYxIDAgMCAwIDQuNzk0IDEuOTgyIDYuNzYgNi43NiAwIDAgMCA0Ljc5NC0xLjk4MyA2Ljc4OCA2Ljc4OCAwIDAgMCAwLTkuNTg5IiBmaWxsPSIjRkZDODNFIiBtYXNrPSJ1cmwoIzVlenpuanExeWIpIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxtYXNrIGlkPSJvZThyNHdsdGJkIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjZG95NDJ4ZXdjYyIvPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZDODNFIiBtYXNrPSJ1cmwoI29lOHI0d2x0YmQpIiBkPSJNNi4yMjIgMTAuNjQ1aDEuMTFWNi4xNDloLTEuMTF6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";